import URL from '@/http/rh/formation/profil';
export default {
  namespaced: true,
  state: {
    currentProfil: null,
    reponses: [
      { text: 'Bon', value: 1 },
      { text: 'Amélioration requise', value: 2 },
      { text: 'Mauvais', value: 3 },
    ],
  },

  getters: {
    currentProfil: (state) => state.currentProfil,
    reponses: (state) => state.reponses,
  },

  mutations: {
    SET_CURRENT_PROFIL(state, payload) {
      state.currentProfil = payload;
    },
  },

  actions: {
    setCurrentProfil({ commit }, payload) {
      commit('SET_CURRENT_PROFIL', payload);
    },
    getProfil({ commit }, payload) {
      commit('SET_CURRENT_PROFIL', null);

      if (payload.edit) {
        return window.axios
          .get(URL.PROFIL + '/' + payload.id, { params: { edit: true } })
          .then((resp) => {
            commit('SET_CURRENT_PROFIL', resp.data.profil);
          })
          .catch(() => {
            commit('SET_CURRENT_PROFIL', null);
          });
      } else {
        return window.axios
          .get(URL.PROFIL + '/' + payload.id)
          .then((resp) => {
            commit('SET_CURRENT_PROFIL', resp.data.profil);
          })
          .catch(() => {
            commit('SET_CURRENT_PROFIL', null);
          });
      }
    },
  },
};
